/**
 * @function rangeNumber
 * @description Give the smallest and largest number given
 * @example
 * rangeNumber(this.allTournaments, 'pricing.0.pricing') // Array index
 * rangeNumber(this.allTournaments, 'pricing.pricing')
 * @param {Array} array The array to search in
 * @param {String} comparisonIndex The index to compare - is used inside a for each loop
 * @returns {object} Return an object containing a min and a max
 * @copyright Spordle
 */
 export const rangeNumber = (array: any[], comparisonIndex: string) => {
    let min: any = null;
    let max: any = null;

    array.forEach(item => {
        let number = parseFloat(comparisonIndex.split('.').reduce((o,i)=>o[i], item));
        if(min === null && max === null){
            min = max = number;
        }
        else if(number < min){
            min = number;
        }
        else if(number > max){
            max = number;
        }
    })
    return {min, max};
}

/**
 * @function rangeDate
 * @description Give the earliest and latest date given
 * @example rangeDate(this.allTournaments, 'pricing.start_date', 'pricing.end_date')
 * @param {Array} dates The array to search in
 * @param {String} comparisonIndexStart The index to compare - is used inside a for each loop
 * @param {String} comparisonIndexEnd The index to compare - is used inside a for each loop
 * @returns {object} Return an object containing a min and a max
 * @copyright Spordle
 */
 export const rangeDate = (dates: any[], comparisonIndexStart: string, comparisonIndexEnd: string) => {
    let min: any = null;
    let max: any = null;

    dates.forEach(date => {
        let dateString = comparisonIndexStart.split('.').reduce((o, current) => o[current], date);

        // min date
        if(min === null){
            min = dateString;
        }
        else if(dateString < min){
            min = dateString;
        }

        dateString = comparisonIndexEnd.split('.').reduce((o, current) => o[current], date);

        // max date
        if(max === null){
            max = dateString;
        }
        else if(dateString > max){
            max = dateString;
        }
    })
    return {min, max};
}

/**
 * @function clamp
 * @description Makes sure the given number is between a given minimum and maximum, returning the minimum or maximum when the number isn't in the limits.
 * @example clamp(3, 0, 10); // 3
 * @example clamp(-5, 0, 10); // 0
 * @example clamp(13, 0, 10); // 10
 * @param {number} val The current number to clamp
 * @param {number} min The minimum value to clamp to
 * @param {number} max The maximum value to clamp to
 * @returns {number} A number that is ether `max`, `min` or `val`
 * @copyright Spordle
 */
export const clamp = (val: number, min: number, max: number): number => Math.min(Math.max(val, min), max);